import React from "react";
import Logo from "../../assets/logos/e-timer_logo_dark.png";
import LeonLogo from "../../assets/logos/Logo-ELD-02 transparent.png";
import EldLogoDarkMode from "../../assets/logos/e-timer_logo_dark_mode.png";
import { useTheme } from "../../context/ThemeContext";
import { Link } from "react-router-dom";
import { dictionary } from "../../dictionary";

const TopBar = () => {
  const isLogged = sessionStorage.getItem("isLoggedIn");
  const { theme } = useTheme();
  
  return (
    <div className="nav">
      <span className="logo-wrapper">
        <img src={theme === 'dark' ? EldLogoDarkMode : Logo} alt="logo" />
        <img id="eld_logo" src={LeonLogo} alt="logo2" />
      </span>
      {!isLogged ? (
        <div className="nav-btn-wrapper">
          <Link id="log_in" to="/access">
            {dictionary.sign_in}
          </Link>
        </div>
      ) : (
        <div className="nav-btn-wrapper">
          <Link id="sign_up" to="/timesheet">
            {dictionary.your_timesheet}
          </Link>
        </div>
      )}
    </div>
  );
};

export default TopBar;
